module.exports = __webpack_public_path__ + "static/APIDomain-2a7984945ef5b89bf7e675799221c31f.png";